import { render, staticRenderFns } from "./DeliverySettingPanel.vue?vue&type=template&id=125ca00e&scoped=true"
import script from "./DeliverySettingPanel.vue?vue&type=script&lang=js"
export * from "./DeliverySettingPanel.vue?vue&type=script&lang=js"
import style0 from "./DeliverySettingPanel.vue?vue&type=style&index=0&id=125ca00e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125ca00e",
  null
  
)

export default component.exports